import React, { useEffect } from "react";
import { AlertCircle, CheckCircle2, X } from "lucide-react";

const Notification = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  const isSuccess = type === "success";
  const Icon = isSuccess ? CheckCircle2 : AlertCircle;

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 flex max-w-sm items-start gap-3 rounded-md border bg-white p-4 text-sm shadow-xl ${
        isSuccess
          ? "border-green-100 text-green-700"
          : "border-red-100 text-red-700"
      }`}
      role="status"
    >
      <Icon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1 font-semibold">{message}</p>
      <button
        type="button"
        onClick={onClose}
        className="grid h-6 w-6 shrink-0 place-items-center rounded-md text-gray-400 transition hover:bg-slate-50 hover:text-gray-700"
        aria-label="Close notification"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
};

export default Notification;
